import { Spin, Typography } from "antd";
import { JournalSectionWrapper } from "@/entities/journal/ui";
import type { JournalPersonCardData, JournalPersonnelSectionConfig } from "../../model/types";
import { useSectionPersonnelData } from "../../model/use-section-personnel-data";
import { JournalPersonCard } from "../journal-person-card";
import { JournalSectionNavTitle } from "../journal-section-nav-title";
// import { JournalSignerDrawer } from "../journal-signer-drawer";
import "./journal-section-personnel.scss";

const EMPTY_SIGNATORIES_TEXT =
  "Список подписантов будет сформирован после добавления данных в раздел";

type JournalSectionPersonnelProps = JournalPersonnelSectionConfig & {
  recordsPath: string;
};

const CardsRow = ({
  cards,
  variant,
  selectedId,
  onSelect,
}: {
  cards: JournalPersonCardData[];
  variant: "signatory" | "responsible";
  selectedId?: string;
  onSelect?: (card: JournalPersonCardData) => void;
}) => {
  if (!cards.length) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }

  return (
    <div className="journal-section-personnel__cards">
      {cards.map((card) => (
        <JournalPersonCard
          key={card.id}
          card={card}
          variant={variant}
          selected={selectedId === card.id}
          onClick={onSelect ? () => onSelect(card) : undefined}
        />
      ))}
    </div>
  );
};

export const JournalSectionPersonnel = ({
  recordsTitle,
  recordsPath,
  sectionNumber,
  sectionType,
  sectionId,
}: JournalSectionPersonnelProps) => {
  const { signatoryCards, responsibleCards, isLoading } = useSectionPersonnelData({
    sectionNumber,
    sectionType,
    sectionId,
  });

  // BUILDDOCS-4961: временно отключено — drawer с доп. инфой при клике на карточку подписанта
  // const [selectedCard, setSelectedCard] = useState<JournalPersonCardData | null>(null);
  // const [drawerOpen, setDrawerOpen] = useState(false);
  //
  // const handleSignatoryClick = (card: JournalPersonCardData) => {
  //   setSelectedCard(card);
  //   setDrawerOpen(true);
  // };

  return (
    <>
      <JournalSectionWrapper>
        <JournalSectionNavTitle
          recordsTitle={recordsTitle}
          recordsPath={recordsPath}
          activeTab="personnel"
        />

        {isLoading ? (
          <div className="journal-section-personnel__loading">
            <Spin />
          </div>
        ) : (
          <div className="journal-section-personnel__sections">
            <section className="journal-section-personnel__section">
              <Typography.Title level={4} className="journal-section-personnel__section-title">
                Подписанты
              </Typography.Title>
              {signatoryCards.length === 0 ? (
                <Typography.Text
                  type="secondary"
                  className="journal-section-personnel__empty-signatories"
                >
                  {EMPTY_SIGNATORIES_TEXT}
                </Typography.Text>
              ) : (
                <CardsRow
                  cards={signatoryCards}
                  variant="signatory"
                  // selectedId={selectedCard?.id}
                  // onSelect={handleSignatoryClick}
                />
              )}
            </section>

            <section className="journal-section-personnel__section">
              <Typography.Title level={4} className="journal-section-personnel__section-title">
                Ответственные лица
              </Typography.Title>
              <CardsRow cards={responsibleCards} variant="responsible" />
            </section>
          </div>
        )}
      </JournalSectionWrapper>

      {/* BUILDDOCS-4961: временно отключено
      <JournalSignerDrawer
        open={drawerOpen}
        card={selectedCard}
        onClose={() => {
          setDrawerOpen(false);
          setSelectedCard(null);
        }}
      />
      */}
    </>
  );
};
